export default {
    /**
     * Shows a toast on the screen
     *
     * @param payload
     */
    ShowToast({}, payload){
        swal.fire(Object.assign({
            position: 'bottom-right',
            showConfirmButton: false,
            heightAuto: false,
            background: '#f2f2f2',
            timer: 3000,
            backdrop: 'rgba(0,0,0,0.0)'
        }, payload));
    },
    ShowLoadingToast({state},payload){
        swal.fire(Object.assign({
            position: 'bottom-right',
            onBeforeOpen: () => {
              swal.showLoading()
            },
          },payload))
    },
     /**
     * Close toast
     */
    CloseToast({}){
        swal.close()
    },
    /**
     * Shows a confirmation dialogue on the
     * screen.
     *
     * @param payload
     * @returns {*|void}
     */
    ShowConfirmationToast({}, payload){
        return swal.fire(Object.assign({
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si'
        }, payload ));
    },
};
